import { getStepFilter } from '@va/dashboard/selectors/ui';
import { useLimitReachedChartRenderers, useLiveChartRenderers } from '@va/ui/design-system';
import { useRefreshCallbacks } from '@va/util/components';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useChartLiveAndLimitData } from './useChartLiveAndLimitData';

export const useChartIndicatorRenderers = () => {
  const { lastVisitDate, refetchLastVisitDate, limitReachedTimestamps, isCurrentlyLimitReached } =
    useChartLiveAndLimitData();
  const { period: unit } = useSelector(getStepFilter);

  useRefreshCallbacks(refetchLastVisitDate);

  const { renderLiveLine, renderLiveHeader } = useLiveChartRenderers({ lastVisitDate, isCurrentlyLimitReached });
  const { renderLimitLines, renderLimitHeader } = useLimitReachedChartRenderers({
    limitReachedTimestamps,
    unit,
    isCurrentlyLimitReached,
  });

  const renderIndicatorLines = useCallback(
    (args: Parameters<typeof renderLiveLine>[0]) => {
      const live = renderLiveLine(args);
      const limit = renderLimitLines(args);
      if (!live && !limit) return null;
      return (
        <>
          {live}
          {limit}
        </>
      );
    },
    [renderLimitLines, renderLiveLine],
  );

  const renderTooltipHeader = useCallback(
    (args: Parameters<typeof renderLiveHeader>[0]) => renderLiveHeader(args) ?? renderLimitHeader(args),
    [renderLimitHeader, renderLiveHeader],
  );

  return { renderIndicatorLines, renderTooltipHeader };
};
